(function () {
  'use strict';

  /* ================================================================
   * LEO & MILO — TEEINBLUE AI LOADER
   *
   * RESPONSIVE VERSION
   *
   * - erkennt automatisch die echte Teeinblue-Hochladefläche
   * - übernimmt deren Position
   * - übernimmt deren Breite
   * - übernimmt deren Höhe
   * - reagiert automatisch auf Größenänderungen
   * - Video läuft unabhängig vom Ladefortschritt
   * ================================================================ */

  const VIDEO_URL =
    'https://cdn.shopify.com/videos/c/o/v/607e48a364e349a282bf32a844ac4b45.mp4';

  const LOADER_CLASS =
    'lm-ai-card-loader';

  const ORIGINAL_PROGRESS_CLASS =
    'lm-ai-original-progress';


  /* ================================================================
   * FALLBACK
   *
   * Nur falls Teeinblue kurzfristig noch keine messbare
   * Hochladefläche bereitstellt.
   *
   * Das sind deine bisher funktionierenden Werte.
   * ================================================================ */

  const FALLBACK_WIDTH = 130;
  const FALLBACK_HEIGHT = 162;


  /* ================================================================
   * STATUS-TEXTE
   * ================================================================ */

  function getStatusText(percent) {

    if (percent <= 25) {
      return 'Dein Foto wird verarbeitet …';
    }

    if (percent <= 50) {
      return 'Moment … war das gerade eine Katze?';
    }

    if (percent <= 75) {
      return 'Okay, kurze Verfolgungsjagd …';
    }

    return 'Fast geschafft – gleich sind wir fertig!';
  }


  /* ================================================================
   * TEEINBLUE-PROZENT AUSLESEN
   * ================================================================ */

  function getProgressPercent(progress) {

    if (!progress) {
      return null;
    }


    /* --------------------------------------------------------------
     * Bevorzugt aria-valuenow
     * -------------------------------------------------------------- */

    const bar =
      progress.querySelector(
        '.tee-progress-bar[aria-valuenow]'
      );


    if (bar) {

      const value =
        parseInt(
          bar.getAttribute('aria-valuenow'),
          10
        );


      if (
        !Number.isNaN(value) &&
        value >= 0 &&
        value <= 100
      ) {
        return value;
      }
    }


    /* --------------------------------------------------------------
     * Fallback: sichtbare Prozentzahl
     * -------------------------------------------------------------- */

    const percentElement =
      progress.querySelector(
        '.tee-progress-percent.text-dark'
      ) ||
      progress.querySelector(
        '.tee-progress-percent'
      );


    if (!percentElement) {
      return null;
    }


    const match =
      (
        percentElement.textContent || ''
      ).match(
        /(\d{1,3})\s*%/
      );


    if (!match) {
      return null;
    }


    const value =
      parseInt(
        match[1],
        10
      );


    if (
      Number.isNaN(value) ||
      value < 0 ||
      value > 100
    ) {
      return null;
    }


    return value;
  }


  /* ================================================================
   * SICHTBARKEIT
   * ================================================================ */

  function isVisible(element) {

    if (!element) {
      return false;
    }


    const style =
      window.getComputedStyle(
        element
      );


    if (
      style.display === 'none' ||
      style.visibility === 'hidden'
    ) {
      return false;
    }


    const rect =
      element.getBoundingClientRect();


    return (
      rect.width > 0 &&
      rect.height > 0
    );
  }


  /* ================================================================
   * VIDEO INITIALISIEREN
   *
   * Das Video wird nur einmal gestartet und danach NICHT mehr
   * vom Fortschrittsbalken angefasst.
   * ================================================================ */

  function initializeVideo(video) {

    if (!video) {
      return;
    }


    video.muted = true;
    video.defaultMuted = true;

    video.autoplay = true;
    video.loop = true;

    video.playsInline = true;

    video.controls = false;

    video.preload = 'auto';


    video.setAttribute(
      'muted',
      ''
    );

    video.setAttribute(
      'autoplay',
      ''
    );

    video.setAttribute(
      'loop',
      ''
    );

    video.setAttribute(
      'playsinline',
      ''
    );

    video.setAttribute(
      'webkit-playsinline',
      ''
    );

    video.removeAttribute(
      'controls'
    );


    function playOnce() {

      const promise =
        video.play();


      if (
        promise &&
        typeof promise.catch === 'function'
      ) {

        promise.catch(
          function () {}
        );

      }
    }


    if (
      video.readyState >= 2
    ) {

      playOnce();

    }


    video.addEventListener(
      'canplay',
      playOnce,
      {
        once: true
      }
    );
  }


  /* ================================================================
   * PHOTO HEAD FINDEN
   * ================================================================ */

  function getPhotoHead(progress) {

    if (!progress) {
      return null;
    }


    return (
      progress.closest(
        '.tee-photo-head'
      ) ||
      progress.closest(
        '.tee-photo'
      ) ||
      null
    );
  }


  /* ================================================================
   * TEEINBLUE-HOCHLADEFLÄCHE ERKENNEN
   *
   * Wichtig:
   *
   * Wir suchen mehrere mögliche Teeinblue-Flächen und nehmen
   * anschließend die kleinste sinnvolle sichtbare Fläche.
   *
   * Dadurch verhindern wir, dass versehentlich der komplette
   * Galerie-Container ausgewählt wird.
   * ================================================================ */

  function getUploadTarget(progress) {

    if (!progress) {
      return null;
    }


    const photoHead =
      getPhotoHead(
        progress
      );


    if (!photoHead) {
      return null;
    }


    const headRect =
      photoHead.getBoundingClientRect();


    const candidates =
      [];


    /* --------------------------------------------------------------
     * 1. Aktiver Teeinblue-Uploading-Bereich
     * -------------------------------------------------------------- */

    const uploading =
      progress.closest(
        '.tee-photo-uploading'
      );


    if (uploading) {
      candidates.push(
        uploading
      );
    }


    /* --------------------------------------------------------------
     * 2. Direkter Placeholder
     * -------------------------------------------------------------- */

    try {

      const directPlaceholder =
        photoHead.querySelector(
          ':scope > .tee-photo-placeholder'
        );


      if (directPlaceholder) {
        candidates.push(
          directPlaceholder
        );
      }

    } catch (error) {}


    /* --------------------------------------------------------------
     * 3. Weitere Placeholder
     * -------------------------------------------------------------- */

    const placeholders =
      photoHead.querySelectorAll(
        '.tee-photo-placeholder'
      );


    placeholders.forEach(
      function (placeholder) {

        if (
          !candidates.includes(
            placeholder
          )
        ) {

          candidates.push(
            placeholder
          );

        }

      }
    );


    /* --------------------------------------------------------------
     * Nur sinnvolle sichtbare Kandidaten
     * -------------------------------------------------------------- */

    const validCandidates =
      candidates.filter(
        function (element) {

          if (
            !element ||
            !isVisible(element)
          ) {
            return false;
          }


          const rect =
            element.getBoundingClientRect();


          /*
           * Viel zu kleine Elemente ignorieren.
           */

          if (
            rect.width < 70 ||
            rect.height < 70
          ) {
            return false;
          }


          /*
           * Element muss innerhalb des Photo-Heads liegen.
           */

          if (
            rect.right <
              headRect.left ||
            rect.left >
              headRect.right
          ) {
            return false;
          }


          /*
           * Schutz:
           *
           * Ein Element, das fast die komplette Galeriebreite
           * einnimmt, ist sehr wahrscheinlich NICHT die kleine
           * Upload-Kachel.
           */

          if (
            headRect.width > 250 &&
            rect.width >
              headRect.width * 0.65
          ) {
            return false;
          }


          return true;

        }
      );


    if (
      !validCandidates.length
    ) {
      return null;
    }


    /* --------------------------------------------------------------
     * Kleinste sinnvolle Fläche auswählen.
     *
     * Dadurch gewinnt normalerweise die echte Upload-Kachel
     * gegen große Wrapper.
     * -------------------------------------------------------------- */

    validCandidates.sort(
      function (a, b) {

        const aRect =
          a.getBoundingClientRect();

        const bRect =
          b.getBoundingClientRect();


        const aArea =
          aRect.width *
          aRect.height;

        const bArea =
          bRect.width *
          bRect.height;


        return (
          aArea -
          bArea
        );

      }
    );


    return validCandidates[0];
  }


  /* ================================================================
   * RESIZE OBSERVER
   *
   * Falls Teeinblue seine Uploadfläche verändert, wird unsere
   * Position automatisch neu berechnet.
   * ================================================================ */

  let resizeUpdateScheduled =
    false;


  function scheduleResizeUpdate() {

    if (
      resizeUpdateScheduled
    ) {
      return;
    }


    resizeUpdateScheduled =
      true;


    requestAnimationFrame(
      function () {

        resizeUpdateScheduled =
          false;

        updateAll();

      }
    );
  }


  const resizeObserver =
    typeof ResizeObserver !==
    'undefined'
      ? new ResizeObserver(
          function () {

            scheduleResizeUpdate();

          }
        )
      : null;


  const observedElements =
    new WeakSet();


  function observeElement(element) {

    if (
      !resizeObserver ||
      !element ||
      observedElements.has(
        element
      )
    ) {
      return;
    }


    observedElements.add(
      element
    );


    resizeObserver.observe(
      element
    );
  }


  /* ================================================================
   * LOADER ENTFERNEN
   * ================================================================ */

  function removeLoader(photoHead) {

    if (!photoHead) {
      return;
    }


    const loader =
      photoHead.querySelector(
        ':scope > .' +
        LOADER_CLASS
      );


    if (loader) {

      const video =
        loader.querySelector(
          '.lm-ai-card-loader__video'
        );


      if (video) {

        try {

          video.pause();

        } catch (error) {}

      }


      loader.remove();
    }


    /* --------------------------------------------------------------
     * Originalen Teeinblue-Progress wieder freigeben
     * -------------------------------------------------------------- */

    const progresses =
      photoHead.querySelectorAll(
        '.tee-progress.' +
        ORIGINAL_PROGRESS_CLASS
      );


    progresses.forEach(
      function (progress) {

        progress.classList.remove(
          ORIGINAL_PROGRESS_CLASS
        );

      }
    );
  }


  /* ================================================================
   * LOADER ERSTELLEN
   * ================================================================ */

  function createLoader(progress) {

    const photoHead =
      getPhotoHead(
        progress
      );


    if (!photoHead) {
      return null;
    }


    let loader =
      photoHead.querySelector(
        ':scope > .' +
        LOADER_CLASS
      );


    /*
     * Nicht neu erstellen.
     *
     * Das ist wichtig, damit auch das Video bestehen bleibt.
     */

    if (loader) {
      return loader;
    }


    /* --------------------------------------------------------------
     * Loader
     * -------------------------------------------------------------- */

    loader =
      document.createElement(
        'div'
      );

    loader.className =
      LOADER_CLASS;


    /* --------------------------------------------------------------
     * Status
     * -------------------------------------------------------------- */

    const status =
      document.createElement(
        'div'
      );

    status.className =
      'lm-ai-card-loader__status';

    status.setAttribute(
      'aria-live',
      'polite'
    );


    /* --------------------------------------------------------------
     * Video Wrapper
     * -------------------------------------------------------------- */

    const videoWrap =
      document.createElement(
        'div'
      );

    videoWrap.className =
      'lm-ai-card-loader__video-wrap';


    /* --------------------------------------------------------------
     * Video
     * -------------------------------------------------------------- */

    const video =
      document.createElement(
        'video'
      );

    video.className =
      'lm-ai-card-loader__video';

    video.src =
      VIDEO_URL;


    videoWrap.appendChild(
      video
    );


    /* --------------------------------------------------------------
     * Fortschrittsbalken
     * -------------------------------------------------------------- */

    const track =
      document.createElement(
        'div'
      );

    track.className =
      'lm-ai-card-loader__track';


    const fill =
      document.createElement(
        'div'
      );

    fill.className =
      'lm-ai-card-loader__fill';


    track.appendChild(
      fill
    );


    /* --------------------------------------------------------------
     * Prozent
     * -------------------------------------------------------------- */

    const percent =
      document.createElement(
        'div'
      );

    percent.className =
      'lm-ai-card-loader__percent';


    /* --------------------------------------------------------------
     * Zusammensetzen
     * -------------------------------------------------------------- */

    loader.appendChild(
      status
    );

    loader.appendChild(
      videoWrap
    );

    loader.appendChild(
      track
    );

    loader.appendChild(
      percent
    );


    photoHead.appendChild(
      loader
    );


    initializeVideo(
      video
    );


    return loader;
  }


  /* ================================================================
   * RESPONSIVE POSITIONIERUNG
   *
   * Hier passiert der entscheidende Unterschied:
   *
   * KEINE festen:
   *
   * width: 130px
   * height: 162px
   * top + 17
   *
   * mehr.
   *
   * Stattdessen messen wir die echte Teeinblue-Fläche.
   * ================================================================ */

  function positionLoader(
    loader,
    progress
  ) {

    if (
      !loader ||
      !progress
    ) {
      return;
    }


    const photoHead =
      getPhotoHead(
        progress
      );


    if (!photoHead) {
      return;
    }


    const headRect =
      photoHead.getBoundingClientRect();


    const target =
      getUploadTarget(
        progress
      );


    /* --------------------------------------------------------------
     * Teeinblue-Ziel gefunden
     * -------------------------------------------------------------- */

    if (target) {

      const targetRect =
        target.getBoundingClientRect();


      const left =
        targetRect.left -
        headRect.left;


      const top =
        targetRect.top -
        headRect.top;


      /*
       * Exakt Position und Größe übernehmen.
       */

      loader.style.left =
        left + 'px';


      loader.style.top =
        top + 'px';


      loader.style.width =
        targetRect.width + 'px';


      loader.style.height =
        targetRect.height + 'px';


      /*
       * Für ResizeObserver registrieren.
       */

      observeElement(
        target
      );


      observeElement(
        photoHead
      );


      return;
    }


    /* --------------------------------------------------------------
     * FALLBACK
     *
     * Falls Teeinblue für einen kurzen Moment noch keine
     * messbare Fläche besitzt, verwenden wir deine bisherige
     * funktionierende Größe.
     * -------------------------------------------------------------- */

    const uploading =
      progress.closest(
        '.tee-photo-uploading'
      );


    let left = 0;
    let top = 0;


    if (uploading) {

      const rect =
        uploading.getBoundingClientRect();


      left =
        rect.left -
        headRect.left;


      top =
        rect.top -
        headRect.top;

    }


    loader.style.left =
      left + 'px';


    loader.style.top =
      top + 'px';


    loader.style.width =
      FALLBACK_WIDTH + 'px';


    loader.style.height =
      FALLBACK_HEIGHT + 'px';
  }


  /* ================================================================
   * ORIGINALEN PROGRESS VERSTECKEN
   * ================================================================ */

  function hideOriginalProgress(progress) {

    if (!progress) {
      return;
    }


    progress.classList.add(
      ORIGINAL_PROGRESS_CLASS
    );
  }


  /* ================================================================
   * FORTSCHRITT AKTUALISIEREN
   *
   * Video wird hier NICHT angefasst.
   * ================================================================ */

  function updateProgress(progress) {

    if (!progress) {
      return;
    }


    const photoHead =
      getPhotoHead(
        progress
      );


    if (!photoHead) {
      return;
    }


    const uploading =
      progress.closest(
        '.tee-photo-uploading'
      );


    /* --------------------------------------------------------------
     * Generierung beendet
     * -------------------------------------------------------------- */

    if (
      !uploading ||
      !isVisible(uploading)
    ) {

      removeLoader(
        photoHead
      );


      return;
    }


    const percentValue =
      getProgressPercent(
        progress
      );


    if (
      percentValue === null
    ) {
      return;
    }


    /* --------------------------------------------------------------
     * 100 %
     * -------------------------------------------------------------- */

    if (
      percentValue >= 100
    ) {

      removeLoader(
        photoHead
      );


      return;
    }


    const loader =
      createLoader(
        progress
      );


    if (!loader) {
      return;
    }


    hideOriginalProgress(
      progress
    );


    /*
     * Position IMMER aktualisieren.
     *
     * Dadurch kann Teeinblue seine Fläche verschieben,
     * ohne dass unser Loader an der alten Stelle hängen bleibt.
     */

    positionLoader(
      loader,
      progress
    );


    /* --------------------------------------------------------------
     * Gleicher Prozentwert?
     *
     * Dann brauchen Text/Balken nicht neu geschrieben werden.
     * -------------------------------------------------------------- */

    const oldPercent =
      parseInt(
        loader.dataset.progress || '-1',
        10
      );


    if (
      oldPercent ===
      percentValue
    ) {
      return;
    }


    loader.dataset.progress =
      String(
        percentValue
      );


    /* --------------------------------------------------------------
     * Status
     * -------------------------------------------------------------- */

    const status =
      loader.querySelector(
        '.lm-ai-card-loader__status'
      );


    if (status) {

      const nextText =
        getStatusText(
          percentValue
        );


      if (
        status.textContent !==
        nextText
      ) {

        status.textContent =
          nextText;

      }
    }


    /* --------------------------------------------------------------
     * Balken
     * -------------------------------------------------------------- */

    const fill =
      loader.querySelector(
        '.lm-ai-card-loader__fill'
      );


    if (fill) {

      fill.style.width =
        percentValue + '%';

    }


    /* --------------------------------------------------------------
     * Prozentzahl
     * -------------------------------------------------------------- */

    const percent =
      loader.querySelector(
        '.lm-ai-card-loader__percent'
      );


    if (percent) {

      const nextPercent =
        percentValue + '%';


      if (
        percent.textContent !==
        nextPercent
      ) {

        percent.textContent =
          nextPercent;

      }
    }
  }


  /* ================================================================
   * ALLE LOADER AKTUALISIEREN
   * ================================================================ */

  function updateAll() {

    const progresses =
      document.querySelectorAll(
        '.tee-photo-uploading .tee-progress'
      );


    progresses.forEach(
      function (progress) {

        updateProgress(
          progress
        );

      }
    );


    /* --------------------------------------------------------------
     * Verwaiste Loader entfernen
     * -------------------------------------------------------------- */

    const loaders =
      document.querySelectorAll(
        '.' + LOADER_CLASS
      );


    loaders.forEach(
      function (loader) {

        const photoHead =
          loader.closest(
            '.tee-photo-head'
          ) ||
          loader.closest(
            '.tee-photo'
          );


        if (!photoHead) {

          loader.remove();


          return;
        }


        const uploading =
          photoHead.querySelector(
            '.tee-photo-uploading'
          );


        if (
          !uploading ||
          !isVisible(uploading)
        ) {

          removeLoader(
            photoHead
          );

        }

      }
    );
  }


  /* ================================================================
   * CSS
   * ================================================================ */

  function addStyles() {

    if (
      document.getElementById(
        'lm-ai-card-loader-styles'
      )
    ) {
      return;
    }


    const style =
      document.createElement(
        'style'
      );


    style.id =
      'lm-ai-card-loader-styles';


    style.textContent = `

      /* ============================================================
       * PHOTO HEAD
       * ============================================================ */

      .tee-photo-head {

        position:
          relative !important;

      }


      /* ============================================================
       * ORIGINALER TEEINBLUE-PROGRESS
       * ============================================================ */

      .tee-photo-uploading
      .tee-progress.${ORIGINAL_PROGRESS_CLASS} {

        position:
          absolute !important;

        width:
          1px !important;

        height:
          1px !important;

        max-width:
          1px !important;

        max-height:
          1px !important;

        margin:
          0 !important;

        padding:
          0 !important;

        opacity:
          0 !important;

        overflow:
          hidden !important;

        pointer-events:
          none !important;

        clip-path:
          inset(50%) !important;

      }


      /* ============================================================
       * LOADER
       * ============================================================ */

      .${LOADER_CLASS} {

        position:
          absolute !important;

        z-index:
          30 !important;

        display:
          flex !important;

        flex-direction:
          column !important;

        align-items:
          center !important;

        justify-content:
          center !important;

        box-sizing:
          border-box !important;

        margin:
          0 !important;

        /*
         * Relativ kleine Innenabstände.
         *
         * Außenmaße kommen vollständig von Teeinblue.
         */

        padding:
          5%
          4%
          4% !important;

        background:
          #FFFFFF !important;

        border:
          0 !important;

        border-radius:
          0 !important;

        overflow:
          hidden !important;

        color:
          #2B2B2B !important;

        font-family:
          inherit !important;

        text-align:
          center !important;

        pointer-events:
          none !important;

      }


      /* ============================================================
       * STATUS
       * ============================================================ */

      .lm-ai-card-loader__status {

        width:
          100%;

        box-sizing:
          border-box;

        margin:
          0
          0
          5%;

        padding:
          0
          2%;

        color:
          #2B2B2B;

        font-family:
          inherit;

        font-size:
          clamp(9px, 2.7vw, 11px);

        font-weight:
          600;

        line-height:
          1.25;

        text-align:
          center;

        white-space:
          normal;

      }


      /* ============================================================
       * VIDEO
       *
       * Responsive innerhalb der erkannten Fläche.
       * ============================================================ */

      .lm-ai-card-loader__video-wrap {

        position:
          relative;

        width:
          106%;

        height:
          48%;

        flex:
          0
          0
          48%;

        display:
          flex;

        align-items:
          center;

        justify-content:
          center;

        box-sizing:
          border-box;

        margin:
          0
          0
          5%;

        padding:
          0;

        overflow:
          hidden;

        background:
          #FFFFFF;

        border:
          0;

      }


      .lm-ai-card-loader__video {

        display:
          block !important;

        width:
          100% !important;

        height:
          100% !important;

        min-width:
          100% !important;

        min-height:
          100% !important;

        max-width:
          100% !important;

        max-height:
          100% !important;

        margin:
          0 !important;

        padding:
          0 !important;

        border:
          0 !important;

        outline:
          0 !important;

        object-fit:
          cover !important;

        object-position:
          center center !important;

        background:
          #FFFFFF !important;

        box-shadow:
          none !important;

        pointer-events:
          none !important;

      }


      /* ============================================================
       * VIDEO-CONTROLS WEG
       * ============================================================ */

      .lm-ai-card-loader__video::-webkit-media-controls,
      .lm-ai-card-loader__video::-webkit-media-controls-enclosure,
      .lm-ai-card-loader__video::-webkit-media-controls-panel,
      .lm-ai-card-loader__video::-webkit-media-controls-play-button,
      .lm-ai-card-loader__video::-webkit-media-controls-start-playback-button {

        display:
          none !important;

      }


      /* ============================================================
       * LADEBALKEN
       * ============================================================ */

      .lm-ai-card-loader__track {

        position:
          relative;

        width:
          81%;

        max-width:
          110px;

        height:
          clamp(5px, 1.7vw, 7px);

        flex:
          0
          0
          auto;

        box-sizing:
          border-box;

        margin:
          0;

        padding:
          0;

        overflow:
          hidden;

        border-radius:
          999px;

        background:
          #D9D9D9;

      }


      /* ============================================================
       * FILL
       * ============================================================ */

      .lm-ai-card-loader__fill {

        position:
          absolute;

        top:
          0;

        left:
          0;

        width:
          0;

        height:
          100%;

        border-radius:
          999px;

        background:
          #2B2B2B;

        transition:
          width
          400ms
          cubic-bezier(0.22, 1, 0.36, 1);

        will-change:
          width;

      }


      /* ============================================================
       * PROZENT
       * ============================================================ */

      .lm-ai-card-loader__percent {

        margin:
          5%
          0
          0;

        padding:
          0;

        color:
          #2B2B2B;

        font-family:
          inherit;

        font-size:
          clamp(9px, 2.8vw, 11px);

        font-weight:
          700;

        line-height:
          1;

        text-align:
          center;

      }


      /* ============================================================
       * SEHR KLEINE HANDYS
       * ============================================================ */

      @media screen and (max-width: 380px) {

        .${LOADER_CLASS} {

          padding:
            4%
            3%
            3% !important;

        }


        .lm-ai-card-loader__status {

          font-size:
            9px;

        }


        .lm-ai-card-loader__video-wrap {

          height:
            46%;

          flex-basis:
            46%;

        }


        .lm-ai-card-loader__track {

          width:
            80%;

        }


        .lm-ai-card-loader__percent {

          font-size:
            10px;

        }

      }

    `;


    document.head.appendChild(
      style
    );
  }


  /* ================================================================
   * UPDATE SCHEDULING
   * ================================================================ */

  let updateScheduled =
    false;


  function scheduleUpdate() {

    if (updateScheduled) {
      return;
    }


    updateScheduled =
      true;


    requestAnimationFrame(
      function () {

        updateScheduled =
          false;

        updateAll();

      }
    );
  }


  /* ================================================================
   * MUTATION OBSERVER
   * ================================================================ */

  const observer =
    new MutationObserver(
      function () {

        scheduleUpdate();

      }
    );


  /* ================================================================
   * BROWSER RESIZE
   * ================================================================ */

  window.addEventListener(
    'resize',
    scheduleUpdate
  );


  /*
   * Bei Geräte-Drehung ebenfalls sofort neu positionieren.
   */

  window.addEventListener(
    'orientationchange',
    function () {

      setTimeout(
        scheduleUpdate,
        100
      );

      setTimeout(
        scheduleUpdate,
        350
      );

    }
  );


  /* ================================================================
   * SICHERHEITS-CHECK
   *
   * Video wird NICHT angefasst.
   * ================================================================ */

  window.setInterval(
    function () {

      if (
        document.querySelector(
          '.' + LOADER_CLASS
        )
      ) {

        updateAll();

      }

    },
    500
  );


  /* ================================================================
   * INIT
   * ================================================================ */

  function init() {

    addStyles();


    updateAll();


    observer.observe(
      document.body,
      {

        childList:
          true,

        subtree:
          true,

        characterData:
          true,

        attributes:
          true,

        attributeFilter: [
          'aria-valuenow'
        ]

      }
    );


    /*
     * Teeinblue kann nachträglich rendern.
     */

    setTimeout(
      updateAll,
      100
    );

    setTimeout(
      updateAll,
      300
    );

    setTimeout(
      updateAll,
      700
    );

    setTimeout(
      updateAll,
      1500
    );

    setTimeout(
      updateAll,
      2500
    );

  }


  /* ================================================================
   * START
   * ================================================================ */

  if (
    document.readyState ===
    'loading'
  ) {

    document.addEventListener(
      'DOMContentLoaded',
      init,
      {
        once:
          true
      }
    );

  } else {

    init();

  }

})();